<template>
  <v-breadcrumbs :items="breadcrumbs" density="compact">
    <template v-if="breadcrumbs" #divider>
      <v-icon
        class="crumb-icon"
        color="#fff"
        icon="mdi:mdi-chevron-right"
        size="small"
      />
    </template>
    <template #item="{ item }">
      <v-breadcrumbs-item class="crumb-link">
        <router-link
          v-if="!item.disabled"
          :to="{ name: getRouteName(item), ...(item.params && { params: item.params }) }"
        >
          {{ item.label }}
        </router-link>
        <span v-else>
          {{ item.label }}
        </span>
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
import { mapGetters } from 'vuex';
import _get from 'lodash/get';

export default {
  watch: {
    /**
     * sets breadcrumbs on route change
     * sets breadcrumbs when app is refreshed on edit_screen
     */
    $route: {
      deep: true,
      handler() {
        const route = this.$route;
        this.$store.dispatch('breadcrumbs/setTrail', {
          params: route.params,
          meta: route.meta,
        });
      },
    },
  },
  computed: {
    breadcrumbs() {
      const trail = [...this.trail];
      // If we're on DynaForm edit and the table is readonly, set the last crumb to 'View'
      // to reinforce that the user can't edit the record
      if (this.$route.name === 'edit_screen') {
        const classMeta = this.$store.getters['meta/class_schema'](this.className);
        if (_get(classMeta, 'table_meta.info.readonly')) {
          trail.splice(trail.length - 1, 1, { label: 'View' });
        }
      }
      return trail;
    },

    ...mapGetters({
      className: 'editObject/class_name',
      trail: 'breadcrumbs/trail',
    }),
  },
  methods: {
    getRouteName(item) {
      if (this.$route.name === 'edit_screen') {
        const className = this.$route.params.classname;
        const foundRoute = this.$router.getRoutes().find(route => route.path === `/${className}`);
        if (foundRoute) return foundRoute.name;
      }
      return item.route_name;
    },
  },
};
</script>

<style lang="scss" scoped>
  .crumb-icon {
    padding-bottom: 2px;
  }

  .crumb-link {
    > a, > span {
      color: lighten($ra-pale-blue, 25);
      text-decoration: none;
      font-size: .9rem;
      font-weight: 500;
      letter-spacing: .02rem;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    > span {
      pointer-events: none;
    }
  }
</style>
